var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
export var useLibraryFilters = function () {
    var history = useHistory();
    var location = useLocation();
    var initialFilters = {
        name: "",
        types: [],
    };
    var _a = useState(initialFilters), filters = _a[0], setFilters = _a[1];
    var _b = useState(initialFilters), appliedFilters = _b[0], setAppliedFilters = _b[1];
    var updateUrlWithFilters = function (newFilters) {
        var params = new URLSearchParams();
        if (newFilters.name)
            params.set("name", newFilters.name);
        newFilters.types.forEach(function (type) { return params.append("types", type); });
        history.push({ search: params.toString() });
    };
    var handleFilterChange = function (field, value) {
        var _a;
        var newFilters = __assign(__assign({}, filters), (_a = {}, _a[field] = value, _a));
        setFilters(newFilters);
    };
    var handleTypeChange = function (type) {
        var newTypes = filters.types.includes(type)
            ? filters.types.filter(function (t) { return t !== type; })
            : __spreadArray(__spreadArray([], filters.types, true), [type], false);
        handleFilterChange("types", newTypes);
    };
    var handleApplyFilters = function () {
        setAppliedFilters(filters);
        updateUrlWithFilters(filters);
    };
    var handleClearFilters = function () {
        var clearedFilters = initialFilters;
        setFilters(clearedFilters);
        setAppliedFilters(clearedFilters);
        history.push({ search: "" });
    };
    var isAnyFilterActive = function () {
        return appliedFilters.name.length > 0 || appliedFilters.types.length > 0;
    };
    var hasUnappliedChanges = function () {
        return JSON.stringify(filters) !== JSON.stringify(appliedFilters);
    };
    useEffect(function () {
        var queryParams = new URLSearchParams(location.search);
        var newFilters = {
            name: queryParams.get("name") || "",
            types: queryParams.getAll("types"),
        };
        if (JSON.stringify(newFilters) !== JSON.stringify(appliedFilters)) {
            setFilters(newFilters);
            setAppliedFilters(newFilters);
        }
    }, [location.search, appliedFilters]);
    return {
        filters: filters,
        appliedFilters: appliedFilters,
        handleFilterChange: handleFilterChange,
        handleTypeChange: handleTypeChange,
        handleApplyFilters: handleApplyFilters,
        handleClearFilters: handleClearFilters,
        isAnyFilterActive: isAnyFilterActive,
        hasUnappliedChanges: hasUnappliedChanges,
    };
};
